import type { AddMaterialType, DeckMaterialKind } from '../../../deck/materials';
import { materialKindOfAddType } from '../../../deck/materials';
import type { IconComponent } from '../../components/Button';
import {
  AudioLines,
  Files,
  FileText,
  Image,
  Layers,
  LetterText,
  Link2,
  Mic,
  Network,
  NotebookPen,
} from '../../icons';

/**
 * THE icon table for deck materials. Tiles, segments and the "+" menu all
 * read from here, on both platforms — one glyph per kind, so a menu row and
 * the tile it produces can never drift apart.
 */
export const DECK_MATERIAL_ICONS: Record<DeckMaterialKind, IconComponent> = {
  document: FileText,
  photos: Image,
  audio: AudioLines,
  youtube: Link2,
  text: LetterText,
  note: NotebookPen,
  mindmap: Network,
};

/** The collapsed "All Sources" segment's glyph. */
export const MATERIALS_OVERVIEW_ICON: IconComponent = Files;

export function addMaterialIcon(type: AddMaterialType): IconComponent {
  // Its tile is an audio source like any other; the ROW says how it is made,
  // so it is not read as a second "Audio".
  if (type === 'record') return Mic;
  return DECK_MATERIAL_ICONS[materialKindOfAddType(type)];
}

/** The deck's own flashcards, as a "generate from" row. Not a material, so
 *  it is not in the table above — but it needs a glyph from the same set. */
export const DECK_FLASHCARDS_ICON: IconComponent = Layers;

export function generationSourceIcon(
  kind: DeckMaterialKind | 'flashcards',
): IconComponent {
  return kind === 'flashcards' ? DECK_FLASHCARDS_ICON : DECK_MATERIAL_ICONS[kind];
}
